import React from 'react';
import { StyledDocumentIcon, StyledDownloadIconWrapper } from './Links.styles';

export default function getLinkText(documentName: string): JSX.Element {
  if (documentName.lastIndexOf(' ') < 0) {
    return (<StyledDownloadIconWrapper>{`${documentName} `}<StyledDocumentIcon /></StyledDownloadIconWrapper>);
  }
  return (<>{`${documentName.substring(0, documentName.lastIndexOf(' '))} `}<StyledDownloadIconWrapper>{`${documentName.substring(documentName.lastIndexOf(' ') + 1, documentName.length)} `}<StyledDocumentIcon /></StyledDownloadIconWrapper></>);
}
